/**
 * トップページのMVで使用するカルーセル
 */
import '../vendor/slick';

export default function() {
  
  jQuery(function($){
    $(`#use-carousel`).slick({
      autoplay: true,
      dots: true,
      dotsClass: 'slide-dots',
      arrows: false,
      fade: true,
      pauseOnHover: false,
      speed: 1000,
      autoplaySpeed: 5000
    })
  })

}
